import { Outlet } from 'react-router-dom';

import { DefaultLayout } from '@/layouts/DefaultLayout';

export const CmsLayout = () => {
  return (
    <DefaultLayout>
      <Outlet />
    </DefaultLayout>
  );
};
